import { ChevronDown, Users } from 'lucide-react'

import { Button } from '@/view/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/view/components/ui/dropdown-menu'

interface PeopleFilterProps {
  people: { id: string; name: string }[]
  selected: string[]
  onToggle: (id: string) => void
  onClear: () => void
}

export const PeopleFilter = ({
  people,
  selected,
  onToggle,
  onClear,
}: PeopleFilterProps) => {
  const label =
    selected.length === 0
      ? 'Todas as pessoas'
      : selected.length === 1
        ? (people.find((person) => person.id === selected[0])?.name ??
          '1 pessoa')
        : `${selected.length} pessoas`

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-between gap-2 font-normal sm:w-[220px]"
        >
          <span className="flex min-w-0 items-center gap-2">
            <Users className="h-4 w-4 shrink-0" />
            <span className="truncate">{label}</span>
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="max-h-80 w-64 overflow-y-auto"
      >
        <DropdownMenuLabel>Filtrar por pessoas</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {people.map((person) => (
          <DropdownMenuCheckboxItem
            key={person.id}
            checked={selected.includes(person.id)}
            onCheckedChange={() => onToggle(person.id)}
            onSelect={(event) => event.preventDefault()}
          >
            {person.name}
          </DropdownMenuCheckboxItem>
        ))}
        {selected.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={onClear}>
              Limpar filtro
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
